import { z } from "zod";

export type VehicleDataParsed = z.infer<typeof VehicleDataSchema>;
export const VehicleDataSchema = z.object({
  vehicle: z.object({
    vehicleId: z.number(),
    vehicleNo: z.string().nullable(),
    modelId: z.number().nullable(),
    makeId: z.number().nullable(),
    vehicleMakeName: z.string().nullable(),
    modelName: z.string().nullable(),
    year: z.number(),
    active: z.boolean(),
    licenseNo: z.string().nullable(),
    licenseState: z.string().nullable(),
    color: z.string().nullable(),
    currentLocationId: z.number().nullable(),
    currentLocationName: z.string().nullable(),
    statusId: z.number(),
    vehicleTypeId: z.number().nullable(),
    vehicleType: z.string().nullable(),
    currentOdometer: z.number().nullable(),
    transmission: z.string().nullable(),
    cylinders: z.number().nullable(),
    memo: z.string().nullable(),
    fuelLevel: z.string().nullable(),
    tankSize: z.number().nullable(),
    createdBy: z.number().nullable(),
    leasingCompanyName: z.string().nullable(),
    insuranceCompanyName: z.string().nullable(),
    fuelType: z.string().nullable(),
    leaseAmt: z.number().nullable(),
    downPayment: z.number().nullable(),
    cashValue: z.number().nullable(),
    vin: z.string().nullable(),
    replaced: z.boolean(),
    vehicleStatus: z.string().nullable(),
    totalRows: z.number().nullable(),
    vehicleImageName: z.string().nullable(),
    currentRenter: z.string().nullable(),
    futureRentalDate: z.string().nullable(),
    leaseRemainingTerm: z.number().nullable(),
    leaseExpiryDate: z.string().nullable(),
    payoutValue: z.number().nullable(),
    purchaseDate: z.string().nullable(),
    inServiceDate: z.string().nullable(),
    roadTaxDate: z.string().nullable(),
    purchaseAmount: z.number().nullable(),
    depreciationAmountPercentage: z.number().nullable(),
    soldAmount: z.number().nullable(),
    soldDate: z.string().nullable(),
    interestPortion: z.number().nullable(),
    insuranceAmount: z.number().nullable(),
    licenseDate: z.string().nullable(),
    expiryDate: z.string().nullable(),
    trim: z.string().nullable(),
    phvExpairyDate: z.string().nullable(),
    phvNumber: z.string().nullable(),
    motExpairyDate: z.string().nullable(),
    inspectionDate: z.string().nullable(),
    inspectionFrequency: z.string().nullable(),
    additionalExpenses: z.number().nullable(),
    spotNumber: z.string().nullable(),
    rateName: z.string().nullable(),
    isReservation: z.boolean(),
    isSale: z.boolean(),
    doors: z.number().nullable(),
    batteryLevel: z.number().nullable(),
    // clientId: 681,
    modelCode: z.string().nullable(),
    origionalOdometer: z.number().nullable(),
    term: z.any(),
    leasingCompanyID: z.number().nullable(),
    createdDate: z.string().nullable(),
    maintenanceEvery: z.number().nullable(),
    insuranceCompanyID: z.number().nullable(),
    ownership: z.string().nullable(),
    tdExpairyDate: z.string().nullable(),
    isNewVehicle: z.boolean(),
    isHighest: z.boolean(),
    plateState: z.coerce.string().nullable(),
    plateType: z.coerce.string().nullable(),
    principalPortion: z.number().nullable(),
    imeiNumber: z.string().nullable(),
    externalDeviceRef: z.string().nullable(),
    createdByName: z.string().nullable(),
    lastUpdatedByName: z.string().nullable(),
    licenseStateName: z.string().nullable(),
  }),
  image: z
    .object({
      imageName: z.string().nullable(),
      imageUrl: z.string().nullable(),
      imageView: z.string().nullable(),
      isActive: z.boolean(),
      vehicleId: z.number().nullable(),
      vehicleImageID: z.number().nullable(),
    })
    .nullable(),
  optionList: z.array(z.any()),
  // vehicleSummary: z.any(),
  userIds: z.array(z.coerce.number()),
  imageList: z.array(
    z.object({
      vehicleImageID: z.number().nullable(),
      vehicleId: z.number().nullable(),
      imageName: z.string().nullable(),
      imageView: z.string().nullable(),
      imageUrl: z.string().nullable(),
      isActive: z.boolean(),
    })
  ),
  addedInventoryItemList: z.array(z.any()),
});
